import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertProps,
  AlertTitle,
} from '@chakra-ui/react';
import * as React from 'react';

export const LogInToView: React.FC<AlertProps & { message?: string }> = ({
  message,
  ...props
}) => {
  return (
    <Alert status="error" {...props}>
      <AlertIcon />
      <AlertDescription>Please log in to view this content.</AlertDescription>
    </Alert>
  );
};
